import { useEffect } from 'react';
import { Autocomplete, TextField, styled } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import { ThemeProvider } from '@mui/material/styles';
import { createTheme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles'
import { ListboxComponent } from '../../../utils/ListHelper';

const BlueAlien = "#1976d2";

const theme = createTheme({
  overrides: {
    MuiInputBase: {
      root: {
        height: '36px !important',
      },
    },
    MuiOutlinedInput: {
      root: {
        height: '36px !important',
      },
    },
    MuiAutocomplete: {
      hasPopupIcon: {
        MuiAutocomplete: {
          hasClearIcon: {
            height: '36px !important',
          }
        }
      },
    },
  }
});

const useStyles = makeStyles({
  formControl: {
    margin: 0,
  },
  root: {
    "&:hover": {
      borderLeft: `4px solid ${BlueAlien} !important`,
    }
  },
  inputStyle: {
    height: '55px !important'
  }
});

const style = {
  select: {
    flex: '0 0 0px',
    padding: '0 5px'
  }
};

export default function DomainValueChooser({codedValues, selectedValue, onChange}) {
  const classes = useStyles();

  useEffect(() => {
    if(selectedValue?.code){
      const tempVal = selectedValue?.code ? selectedValue.code : "";
      onChange(tempVal);
    } else if(selectedValue){
      const tempVal = selectedValue ? selectedValue : "";
      onChange(tempVal);
    }
  }, [selectedValue])

  const AutoCompleteStyled = styled(Autocomplete)`
  & .MuiInputBase-input {
    height: '36px';
    paddingTop: 0;
    paddingBottom: 1;
  }
`;

  const handleOnChange = (event, value) => {
    let selectedCode = value ? value : '';
    let selectedCodeValue = '';
    if(codedValues?.length){
      selectedCodeValue = codedValues.filter(x => x === selectedCode) ? codedValues.filter(x => x === selectedCode)[0] : '';
    }
    onChange(selectedCodeValue);
  };

  return (
    <ThemeProvider theme={theme}>
      <FormControl variant="outlined" className={classes.formControl}>
      <AutoCompleteStyled
        style={style.select}
        multiple={false}
        defaultValue={''}
        value={ selectedValue?.code ?? selectedValue }
        disablePortal
        options={codedValues}
        size="small"
        onChange={handleOnChange}
        sx={{ width: 300 }}
        clearText='Defaults to first option'
        renderInput={(params) => (
          <TextField
            {...params}
            slotProps={{
              input: {
                ...params.InputProps,
                classes: {root: classes.inputStyle},
              }
            }}
          />
        )}
        slotProps={{ 
          listbox: {
            component: ListboxComponent
          }
        }}
        renderOption={(props, option, state) => [props, option, state?.index]}
        disableListWrap
      />
      </FormControl>
    </ThemeProvider>
  );
}